import css from 'styled-jsx/css';

const staticStyles = css`
  .TabWazzup {
    width: 100%;
    min-width: 0;
  }
  iframe {
    display: block;
    width: 100%;
    height: 70vh;
    min-height: 400px;
    border: 0;
  }
  .TabWazzup__status {
    padding: 32px 16px;
    text-align: center;
    overflow-wrap: anywhere;
  }
`;

export { staticStyles };
